var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolUda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91599 0.683865C4.87657 0.66093 4.82817 0.66105 4.78887 0.684181L0.785672 3.03982C0.744886 3.06279 0.719611 3.10658 0.719727 3.15409C0.723528 4.7067 0.73162 7.85877 0.73162 7.85877C0.734919 7.90129 0.758524 7.93973 0.795127 7.96125C0.796042 7.96179 0.796961 7.96231 0.797886 7.96283C3.47479 9.52093 6.12918 11.0905 8.80637 12.6484C8.84589 12.6714 8.89443 12.6712 8.93377 12.6479C8.97312 12.6246 8.99734 12.5817 8.99734 12.5353C8.99734 9.40118 8.99957 6.26511 8.99957 3.13095C8.99957 3.08421 8.97499 3.04106 8.93518 3.01789L4.91599 0.683865ZM4.74783 5.71647L1.11565 7.848L4.74783 9.96214L4.74783 5.71647ZM0.975618 3.37157L4.6188 5.49177L0.986029 7.62365L0.975618 3.37157ZM5.00324 9.96089L8.63301 7.82842L5.00324 5.71583L5.00324 9.96089ZM5.13177 5.49076L8.7448 3.36288L8.761 7.60304L5.13177 5.49076ZM8.62121 3.13496L4.85306 0.947005L1.10978 3.14986L4.87511 5.34115L8.62121 3.13496ZM8.74198 12.3112L5.13225 10.1858L8.77282 8.05303L8.74198 12.3112Z",
    fill: "#212632",
    stroke: "#212632",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolUda);
export default __webpack_public_path__ + "static/media/symbolUda.272f8e0c0afa6b099f4656ff8d7259fe.svg";
export { ForwardRef as ReactComponent };